import { VFC } from 'react'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { Button, ButtonsDiv, CancelButton, Layout } from './styles'

const GroupRestore: VFC<
  ModalProps<{ restoreDeletedGroup: () => Promise<any> }>
> = ({ restoreDeletedGroup, close }) => (
  <Layout>
    <h3>削除済のルームを復元しますか？</h3>
    <ButtonsDiv>
      <CancelButton onClick={close}>キャンセル</CancelButton>
      <Button
        onClick={async () => {
          await restoreDeletedGroup()
          window.location.reload()
        }}
      >
        復元
      </Button>
    </ButtonsDiv>
  </Layout>
)

export const GroupRestoreModal = asModal(GroupRestore)
